import campaignsRpcClient from '../api/campaignsRpcClient';
import { getCampaignRpc, createCampaignRpc, updateCampaignRpc, patchCampaignRpc, deleteCampaignRpc, getCampaignsByGuidsRpc, getCampaignsCountRpc, hasCampaignsRpc, getCampaignByUtmRpc, getCampaignsColorsRpc, deleteCampaignsRpc, crmPropertiesBulkUpdateRpc, getCampaignsPaginatedRpc, getCstMeetingLinkRpc } from '../../__generated__/chirp/com/hubspot/marketing/campaigns/rpc/CampaignsRpc';
import { getCampaignCrmHydratedRpc } from '../../__generated__/chirp/com/hubspot/marketing/campaigns/rpc/CampaignsCrmHydratedRpc';
import { cloneCampaignRpc } from '../../__generated__/chirp/com/hubspot/marketing/campaigns/rpc/CampaignCloningRpc';
export function getCampaignByGuid(campaignGuid) {
  return campaignsRpcClient.call(getCampaignRpc, {
    request: {
      campaignGuid
    }
  });
}
export function createCampaign(request) {
  return campaignsRpcClient.call(createCampaignRpc, {
    request
  });
}
export function updateCampaign(request) {
  return campaignsRpcClient.call(updateCampaignRpc, {
    request
  });
}
export function patchCampaign(request) {
  return campaignsRpcClient.call(patchCampaignRpc, {
    request
  });
}
export function deleteCampaign(campaignGuid) {
  return campaignsRpcClient.call(deleteCampaignRpc, {
    request: {
      campaignGuid
    }
  });
}
export function getCampaignsByGuids(campaignGuids) {
  return campaignsRpcClient.call(getCampaignsByGuidsRpc, {
    request: {
      campaignGuids
    }
  });
}
export function getCampaignsCount() {
  return campaignsRpcClient.call(getCampaignsCountRpc, {});
}
export function hasCampaigns() {
  return campaignsRpcClient.call(hasCampaignsRpc, {});
}
export function getCampaignByUtm(utm) {
  return campaignsRpcClient.call(getCampaignByUtmRpc, {
    request: {
      utm
    }
  });
}
export function getCampaignsColors(request) {
  return campaignsRpcClient.call(getCampaignsColorsRpc, {
    request
  });
}
export function deleteCampaigns(request) {
  return campaignsRpcClient.call(deleteCampaignsRpc, {
    request
  });
}
export function crmPropertiesBulkUpdate(request) {
  return campaignsRpcClient.call(crmPropertiesBulkUpdateRpc, {
    request
  });
}
export function getCampaignsPaginated(request) {
  return campaignsRpcClient.call(getCampaignsPaginatedRpc, {
    request
  });
}
export function getCstMeetingLink() {
  return campaignsRpcClient.call(getCstMeetingLinkRpc, {});
}
export function getCampaignCrmHydrated(campaignGuid, includeSteps) {
  return campaignsRpcClient.call(getCampaignCrmHydratedRpc, {
    request: {
      campaignGuid,
      includeSteps
    }
  });
}
export function cloneCampaign(request) {
  return campaignsRpcClient.call(cloneCampaignRpc, {
    request
  });
}